import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginPage from './pages/LoginPage';
import ProfileSetupPage from './pages/ProfileSetupPage';
import DashboardPage from './pages/DashboardPage';
import MealPlannerPage from './pages/MealPlannerPage';
import SavedPlansPage from './pages/SavedPlansPage';
import YouTubeMealCreator from './pages/YouTubeMealCreator';
import CustomMealsPage from './pages/CustomMealsPage';
import CustomWeeklyPlanPage from './pages/CustomWeeklyPlanPage';
import CommunityPage from './pages/CommunityPage';
import Navigation from './components/Navigation';
// In frontend/src/App.js, add the new route
import FoodDatabasePage from './pages/FoodDatabasePage';


// Simple Layout component
const Layout = ({ children }) => (
  <>
    <Navigation />
    <main className="min-h-screen">
      {children}
    </main>
  </>
);

// Protected Route (allows guest mode)
const ProtectedRoute = ({ children, requireAuth = false }) => {
  const { user, loading, guestMode } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="body-large">Loading...</p>
      </div>
    );
  }

  // If auth is required and user is not logged in (guest mode doesn't count)
  if (requireAuth && !user) {
    return <Navigate to="/login" />;
  }

  // Allow access if user is logged in OR in guest mode (unless auth is required)
  return (user || guestMode) ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <BrowserRouter>
          <Routes>
            {/* Default route - redirects to /meal-planner */}
            <Route path="/" element={
              <ProtectedRoute>
                <MealPlannerPage />
              </ProtectedRoute>
            } />
            
            {/* Other routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/profile-setup" element={<ProtectedRoute requireAuth={true}><ProfileSetupPage /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requireAuth={true}><DashboardPage /></ProtectedRoute>} />
            <Route path="/saved-plans" element={<ProtectedRoute><SavedPlansPage /></ProtectedRoute>} />
            <Route path="/youtube-meal" element={<ProtectedRoute><YouTubeMealCreator /></ProtectedRoute>} />
            <Route path="/custom-meals" element={<ProtectedRoute><CustomMealsPage /></ProtectedRoute>} />
            <Route path="/custom-weekly-plan" element={<ProtectedRoute><CustomWeeklyPlanPage /></ProtectedRoute>} />
            <Route path="/food-database" element={
              <ProtectedRoute>
                <FoodDatabasePage />
              </ProtectedRoute>
            } />
            <Route path="/community" element={<ProtectedRoute><CommunityPage /></ProtectedRoute>} />

            {/* Catch-all route - redirects to home */}
            <Route path="*" element={
              <Navigate to="/" replace />
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;